import { render } from "./taskMenusEditor.vue?vue&type=template&id=4edb8350"
import script from "./taskMenusEditor.vue?vue&type=script&lang=js"
export * from "./taskMenusEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__